import React, { useContext } from 'react';
import Link from '~/components/link';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { paths } from '~/../shared/routing';
import { getPath } from '~/../shared/utils';
import { LangContext } from '~/components/../providers/LangProvider';

const BlogItemNotExists = ({ country }) => {
    const ctxLang = useContext(LangContext);

    return (
        <BlogItemNotExistsContainer>
            <Title>
                <Trans id="blog.notFound" />
            </Title>
            <Button>
                <Link href={getPath(paths.blog, ctxLang.state.country)}>
                    <Trans id="blog.backToBlog" />
                </Link>
            </Button>
        </BlogItemNotExistsContainer>
    );
};

export default BlogItemNotExists;

const BlogItemNotExistsContainer = styled.div`
    margin: 2rem auto 0 auto;
    text-align: center;
    max-width: 700px;
    padding-top: 2rem;
    padding-bottom: 10rem;
`;

const Title = styled.h2`
    margin-bottom: 1rem;
`;

const Button = styled.div`
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: all 0.15s ease-in-out;
    background-color: #28a745;
    border-color: #28a745;

    a {
        color: white !important;
    }

    &:hover {
        background-color: #218838;
        border-color: #1e7e34;
    }
`;
